"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerLogin = void 0;
const React = require("react");
const react_1 = require("react");
const Form_1 = require("../../../../../components/base/forms/Form");
const Message_1 = require("../../../../../components/base/atoms/Message");
const errorTypes_1 = require("../../../../../apis/spg/helpers/errorTypes");
const SlimSection_1 = require("../../../../../components/base/structure/SlimSection");
const useClient_1 = require("../../../../../hooks/useClient");
const localStorageKey_1 = require("../helpers/localStorageKey");
const formSchema = [
    {
        type: "email",
        required: true,
        label: "Email",
        map: "email",
        hideKeypad: true
    },
    {
        type: "password",
        required: true,
        label: "Password",
        map: "password"
    }
];
const RetailCustomerLogin = ({ children, onCompletion }) => {
    const client = (0, useClient_1.useClient)();
    const [error, setError] = (0, react_1.useState)(null);
    const onSuccessHandler = (0, react_1.useCallback)((data) => {
        const { email, password } = data;
        return client.auth
            .loginAsCustomer(email, password)
            .then((retailCustomer) => {
            // call onCompletion from parent component "RetailCustomerWrapper"
            onCompletion && onCompletion(retailCustomer);
        })
            .catch((e) => {
            if (e instanceof errorTypes_1.InvalidCredentialsError) {
                // bad credentials
                setError("Please double check your credentials and try again.");
            }
            else {
                setError("It looks like something went wrong. Please try again.");
                throw e;
            }
        });
    }, [onCompletion]);
    return (React.createElement(SlimSection_1.SlimSection, null,
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Log in")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            React.createElement(Form_1.Form, { schema: formSchema, onSuccess: data => {
                    setError(null);
                    // if success, store customer email to be handily reused as default value on email field
                    window.localStorage.setItem(localStorageKey_1.TLocalStorageKey.Email, data.email);
                    onSuccessHandler(data);
                }, disableOnSuccess: false, data: {
                    email: window.localStorage.getItem(localStorageKey_1.TLocalStorageKey.Email)
                }, submitLabel: "Login" }),
            children,
            error !== null && (React.createElement(Message_1.ErrorMessage, null,
                React.createElement(Message_1.MessageTitle, null, "Unable to login"),
                React.createElement(Message_1.MessageBody, null, error))))));
};
exports.RetailCustomerLogin = RetailCustomerLogin;
//# sourceMappingURL=index.js.map